const convert_string_boolean_to_boolean = (value) => {
  return value == "true" ? true : false
};

const bxSliderLoading = (bxslider) => {
  const hash_bxslider = 
  {
    minSlides: bxslider.getAttribute("data-minslides"),
    maxSlides: bxslider.getAttribute("data-maxslides"),
    mode: bxslider.getAttribute("data-mode"),
    adaptiveHeight: convert_string_boolean_to_boolean(bxslider.getAttribute("data-adaptiveheight")),
    pager: convert_string_boolean_to_boolean(bxslider.getAttribute("data-pager")),
    captions: convert_string_boolean_to_boolean(bxslider.getAttribute("data-captions")),
    auto: convert_string_boolean_to_boolean(bxslider.getAttribute("data-auto")),
    ticker: convert_string_boolean_to_boolean(bxslider.getAttribute("data-ticker")),
    speed: bxslider.getAttribute("data-speed"),
    pause: bxslider.getAttribute("data-pause")
  };

  if (bxslider.getAttribute("data-slidewidth")) { hash_bxslider["slideWidth"] = bxslider.getAttribute("data-slidewidth") };
  if (bxslider.getAttribute("data-slidemargin")) { hash_bxslider["slideMargin"] = bxslider.getAttribute("data-slidemargin") };
  $('.bxslider').bxSlider(hash_bxslider);
}

document.addEventListener("DOMContentLoaded",()=>{
  const bxslider = document.querySelector(".boxslider");
  if (bxslider) { bxSliderLoading(bxslider) };
});


// WEBPACK FOOTER //
// ./app/frontend/packs/bxslider.js